import { render, staticRenderFns } from "./CommonPartListItem.vue?vue&type=template&id=a20b4956&scoped=true&"
import script from "./CommonPartListItem.vue?vue&type=script&lang=js&"
export * from "./CommonPartListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b4956",
  null
  
)

export default component.exports